/*
 * PKCE early bootstrap — must run before any heavy imports to short-circuit app loading
 * when the page is a PKCE redirect/popup completion (the page will be replaced or closed)
 */
import { isPkceRequired } from '@blk/aw-env-detection';
import { handlePkceAuthorizationCompletionBootstrap } from './hooks/usePkceCodeAuthorization/pkceCompletionBootstrap';

const pkceConsumedPage = isPkceRequired() && handlePkceAuthorizationCompletionBootstrap(window.localStorage);

if (!pkceConsumedPage) {
  // Normal app initialisation — only when PKCE did not consume the page
  void import('./main');
}
